import React from 'react';
import './Loader.css';
import icon from '../../assets/svg/loading.gif';

const Loader = (props) => props.visible && (
  <div className='Loader'>
    <div className='Loader-container'>
      <img src={icon} className='Loader-logo' alt='logo' />
      <p className="textocargando">Cargando....</p>
    </div>
  </div>
);

Loader.defaultProps = {
  visible: false
}

export default Loader;